import { meetingTypeActions } from './meeting-type.actions';
import { CoreAppState } from '../core-app.state';
import {
  BaseResourceState,
  createBaseResourceReducer,
  initialResourceState,
} from '../create-base-resource-reducer';
import { MeetingTypeResourceTypeMappings } from '@aa/nest/resource';

export type MeetingTypeState =
  BaseResourceState<MeetingTypeResourceTypeMappings>;
export const initialMeetingTypeState: MeetingTypeState = initialResourceState;

export const meetingTypeReducer = createBaseResourceReducer<
  MeetingTypeResourceTypeMappings,
  MeetingTypeState
>(initialMeetingTypeState, meetingTypeActions);

export const selectMeetingTypeState = (state: CoreAppState) =>
  state.meetingType ?? initialMeetingTypeState;
